<script setup lang="ts">

</script>

<template>
  <Transition
      enter-active-class="transition-all duration-200 ease-out"
      leave-active-class="transition-all duration-100 ease-in"
      enter-from-class="opacity-0 translate-y-1 scale-98"
      leave-to-class="opacity-0 -translate-y-1 scale-98"
      mode="out-in"
  >
    <slot />
  </Transition>
</template>

<style scoped>

</style>